import React from 'react'
import { WorkfastLogo } from '../svg';
import { useLocation } from 'react-router-dom';





export default function Desktop() {
    const location = useLocation();
    const [position, setPosition] = React.useState(window.innerWidth);

    React.useEffect(() => {
        window.onresize = function () {
            setPosition(window.innerWidth);
        };
    }, []);


    return (
        <div className={`flex justify-between items-center h-[80px] mx-auto px-[22px] py-[12px] z-[55] top-[20px] inset-x-[40px] rounded-[20px] fixed bg-[#FFFFFF]`} style={{ boxShadow: "0px 0px 4px 0px #00000040" }}>
            <a title='Workfast' href='/'>
                <div className='px-[8px] lg:px-[12px] py-[12px] lg:py-[8px] rounded-[16px] relative z-[20] bg-white' style={{ boxShadow: '0px 4px 7px 0px #432E860A' }}>
                    <WorkfastLogo width={position >= 1024 ? "156" : "100"} height={position >= 1024 ? "33" : "25"} />
                </div>
            </a>
            <div className={`flex relative gap-[20px] items-center z-[20]`}>
                <div className={`text-[13px] lg:text-[16px] cursor-pointer rounded-[8px] px-[8px] lg:px-[14px] py-[12px] lg:py-[8px] ${location?.pathname === "/" ? "text-[#B69D00] font-semibold bg-[#FFDD0933]" : "text-[#24223E] font-normal"}`} onClick={(e) => { window.location.href = '/' }}>Surge Student</div>
                <div className={`text-[13px] lg:text-[16px] cursor-pointer rounded-[8px] px-[8px] lg:px-[14px] py-[12px] lg:py-[8px] ${location?.pathname === "/surge-colleges" ? "text-[#B69D00] font-semibold bg-[#FFDD0933]" : "text-[#24223E] font-normal"}`} onClick={(e) => { window.location.href = '/surge-colleges' }}>Surge College</div>
                <div className={`text-[13px] lg:text-[16px] cursor-pointer rounded-[8px] px-[8px] lg:px-[14px] py-[12px] lg:py-[8px] ${location?.pathname === "/surge-speakers" ? "text-[#B69D00] font-semibold bg-[#FFDD0933]" : "text-[#24223E] font-normal"}`} onClick={(e) => { window.location.href = '/surge-speakers' }}>Surge Speakers</div>
            </div>
            <button className={`p-[30px] rounded-[16px] hidden md:flex gap-[10px] items-center bg-[#34C759] relative z-[20] h-[47px] font-semibold text-[#FFF] text-[16px]`}
                onClick={() => {
                    const slotDiv = document.getElementById("slot");
                    if (slotDiv) {
                        slotDiv.scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                }}>Enrol for {location?.pathname === "/" ? "Surge Student" : location?.pathname === "/surge-colleges" ? "Surge College" : "Surge Speakers"}</button>
        </div>
    )
}